__turbopack_context__.v({
  "boldSpan": "BCh8gq_boldSpan",
  "fullWidthRow": "BCh8gq_fullWidthRow",
  "imageTextContainer": "BCh8gq_imageTextContainer",
  "imageWrapper": "BCh8gq_imageWrapper",
  "root": "BCh8gq_root",
  "splitImage": "BCh8gq_splitImage",
  "splitImageContainer": "BCh8gq_splitImageContainer",
  "textContainer": "BCh8gq_textContainer",
  "textPara": "BCh8gq_textPara",
  "titleContainer": "BCh8gq_titleContainer",
  "titleP": "BCh8gq_titleP",
});
